import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getServices = async () => {
    const { data, error } = await supabase
        .from('service_pricing_duration')
        .select(`*, services(*)`)

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetAllServicePricingDuration() {
    return useQuery({
        queryKey: ['useGetAllServicePricingDuration'],
        queryFn: () => getServices(),
        staleTime: 1000 * 60 * 5, // 5 minutes
    })
}
